module.exports = __webpack_public_path__ + "static/media/loading.f61ba2b6.mp4";